import React from 'react';
import { useThemeSettings } from '@/hooks/useThemeSettings';

// Default logo shipped with the build. Lives at /app/frontend/public/logo.png.
// Override at runtime by setting `theme_settings.main_logo` via Admin → Brand.
const DEFAULT_LOGO_SRC = '/logo.png';

const Logo = ({ size = 'default', showText = true }) => {
  const { themeSettings } = useThemeSettings();

  const sizeClasses = {
    small: 'h-8 w-8',
    default: 'h-10 w-10',
    large: 'h-14 w-14',
  };

  const textClasses = {
    small: 'text-lg',
    default: 'text-xl',
    large: 'text-2xl',
  };

  const logoSrc = themeSettings.main_logo || DEFAULT_LOGO_SRC;

  return (
    <div className="flex items-center gap-3" data-testid="logo">
      <img
        src={logoSrc}
        alt="TheUnityBlaze Connection"
        className={`${sizeClasses[size]} object-contain`}
      />
      {showText && (
        <div className="flex flex-col">
          <span className={`font-bold ${textClasses[size]} tracking-tight leading-none`}>
            <span className="text-foreground">The</span>
            <span className="text-foreground">Unity</span>
            <span className="text-primary">Blaze</span>
          </span>
          <span className="text-xs text-muted-foreground tracking-widest uppercase">
            Connection
          </span>
        </div>
      )}
    </div>
  );
};

export default Logo;
